// src/pages/AboutUs.jsx
import React from "react";
import innerBanner from "../Images/inner-banner-image.jpg";
import { Link } from "react-router-dom";
import { Nav } from "react-bootstrap";
import aboutImage1 from "../Images/30.png";
import aboutImage2 from "../Images/32.png";
import aboutImage3 from "../Images/33.png";
import certification1 from '../Images/certifications-2.png';
import certification2 from '../Images/certifications-5.png';
import certification3 from '../Images/ZDHC-Black.png';
import Footer from '../Components/Footer'

const AboutUs = () => {
  return (
    <div>
      <div className="inner-banner-section">
        <img src={innerBanner} alt="inner-banner" />
        <div className="inner-banner-heading">
          <span>About us</span>
        </div>
      </div>
      {/* --------------------------------------------------- */}
      <div className="about-section-1">
        <div className="container">
          <div className="about-section-1-cont">
            <div className="about-section-1-left">
              <h1>
                Best <span>Yarn</span> Dyers
              </h1>
              <hr />
              <p>
                Commissioned in the year 2005,{" "}
                <span>Shivasakthi Fashions Pvt Ltd</span> is one of the most
                reputed <span>Yarn Dyeing Units</span> in the Textile Processing
                hub in Sipcot Industrial Growth Centre, Perundurai, Erode
                District.
              </p>
              <p>
                Nearing two decades of successful functioning, the unit got
                established themselves for its Quality, Timely Delivery at Right
                Price. Because of this experience we continue to serve the
                Domestic and Export Textiles Industries to meet their
                commitments. This experience and commitments have earned us
                handful of customers, naming few are Santex Inc, Tirupur, Aditya
                Exports Erode, Asian Fabrixs Pvt Ltd., Karur and JVS Exports
                Karur., A S Creations Salem.
              </p>
              <button>
                <Nav.Link as={Link} to="/contact">
                  For Enquiry
                </Nav.Link>
              </button>
            </div>
            <div className="about-section-1-right">
              <div className="about-image" id="about-image-1">
                <img src={aboutImage1} alt="about-image" />
              </div>
              <div className="about-image">
                <div className="about-image" id="about-image-2">
                  <img src={aboutImage2} alt="about-image" />
                </div>
                <div className="about-image" id="about-image-3">
                  <img src={aboutImage3} alt="about-image" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* ---------------------------------------------------------- */}
      <div className="about-section-2">
        <div className="container">
          <div className="about-section-2-cont">
            <div className="about-section-2-left">
              <h2><span>Our</span> Mission</h2>
              <p>
                At M/s Shivasakthi Fashions, our mission is to deliver
                high-quality yarn-dyed garments with precision, sustainability,
                and innovation. We aim to exceed customer expectations by
                ensuring colorfastness, consistency, and timely delivery, while
                upholding ethical business practices and contributing to
                environmental conservation.
              </p>
            </div>
            <div className="vr-line"></div>
            <div className="about-section-2-right">
              <h2><span>Our</span> Vision</h2>
              <p>
                To be a global leader in the yarn-dyeing industry, recognized
                for our commitment to quality, sustainability, and customer
                satisfaction. We aspire to build lasting relationships and
                continuously improve through innovation, ensuring long-term
                value for our customers and a positive impact on society.
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* ------------------------------------------------- */}
      <div className="about-section-3">
        <div className="container">
          <div className="about-section-3-cont">
            <h2>Certification</h2>
            <h4>We are holding certifications from</h4>
            <div className="certification-section">
              <div className="certificate">
                <img src={certification1} alt="certification" width={200} />
              </div>
              <div className="certificate">
                <img src={certification2} alt="certification"  width={200} />
              </div>
              <div className="certificate">
                <img src={certification3} alt="certification"  width={200} />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* ------------------------------------------------ */}
      <Footer/>
    </div>
  );
};

export default AboutUs;
